export const FILE_UPLOAD_V3_OPTION_KEYS = ['ttl', 'expiresAt', 'folderId', 'folderPath', 'overwrite'];